import { MoloniOauthComponent } from './dashboard/moloni-oauth/moloni-oauth.component';
import { Routes } from '@angular/router';
import { UserGuard } from './core/guards/user.guard';
import { MerchantGuard } from './core/guards/merchant.guard';
import { BukAdminGuard } from './core/guards/buk-admin.guard';
import { GlobalParamsGuard } from './core/guards/global-params.guard';
import { SetLanguageGuard } from './core/guards/set-language.guard';
import { environment } from '../environments/environment';
import { RoleAdminGuard } from './core/guards/role.admin.guard';
import { HasActiveSubscriptionGuard } from './core/guards/has-active-subscription.guard';
import { landingRoutes } from './landing/landing-routing.module';
import { supportRoutes } from './support/support-routing.module';
import { adminRoutes } from './admin/admin-routing.module';
import { dashboardRoutes } from './dashboard/dashboard-routing.module';
import { ImpersonateAdminComponent } from './admin/impersonate-admin/impersonate-admin.component';
import { AdminComponent } from './admin/admin.component';
import { clientEditorRoutes } from './client-editor/client-editor-routing.module';
import { onboardRoutes } from './onboard/onboard-routing.module';
import { clientRoutes } from './client/client-routing.module';
import { ClientComponent } from './client/client.component';
import { TeyaOauthComponent } from './dashboard/teya-oauth/teya-oauth.component';

const languageRoutes: Routes = environment.languages.map((language) => ({
  path: language.code,
  children: landingRoutes,
  pathMatch: 'full',
  data: { state: 'subdomainLanguage' },
  canActivate: [SetLanguageGuard, GlobalParamsGuard],
}));

export const routes: Routes = [
  { path: '', canActivate: [GlobalParamsGuard], data: { state: 'landing' }, children: landingRoutes },
  { path: 'support', children: supportRoutes, data: { state: 'client' } },
  {
    path: 'teicjpi7423ntgcphkz9',
    loadComponent: () => Promise.resolve(ImpersonateAdminComponent),
    canActivate: [],
    data: { state: 'impersonateAdmin' },
  },
  {
    path: 'logout',
    pathMatch: 'full',
    children: landingRoutes,
  },
  { path: 'admin', component: AdminComponent, children: adminRoutes, canActivate: [BukAdminGuard ] },
  {
    path: 'cancel-subscription',
    loadComponent: () =>
      import('./cancelation/cancel-subscription-page/cancel-subscription-page.component').then((m) => m.CancelSubscriptionPageComponent),
    canActivate: [UserGuard, MerchantGuard, RoleAdminGuard, HasActiveSubscriptionGuard],
  },
  {
    path: 'dashboard',
    children: dashboardRoutes,
    canActivate: [UserGuard, MerchantGuard],
    data: { state: 'dashboard' },
  },
  {
    path: ':slug/editor',
    children: clientEditorRoutes,
    canActivate: [UserGuard, MerchantGuard, RoleAdminGuard],
    data: { state: 'client' },
  },
  {
    path: ':slug/dashboard',
    children: dashboardRoutes,
    canActivate: [UserGuard, MerchantGuard],
    data: { state: 'dashboard' },
  },
  {
    path: 'setup',
    children: onboardRoutes,
    canActivate: [UserGuard],
    data: { state: 'onboard' },
  },
  {
    path: 'moloni/auth',
    canActivate: [UserGuard, MerchantGuard],
    pathMatch: 'full',
    component: MoloniOauthComponent,
  },
  {
    path: 'teya/oauth/callback',
    pathMatch: 'full',
    canActivate: [UserGuard, MerchantGuard],
    component: TeyaOauthComponent,
  },
  {
    path: 'qr/:uuid',
    component: ClientComponent,
    children: clientRoutes,
    canActivate: [],
  },
  ...languageRoutes,
  {
    path: ':slug',
    component: ClientComponent,
    children: clientRoutes,
    canActivate: [SetLanguageGuard],
  },
  {
    path: ':slug/**',
    component: ClientComponent,
    canActivate: [SetLanguageGuard],
    children: clientRoutes,
  },
  { path: '**', redirectTo: '' },
];
